const type = {
   OPEN_CLOSE_PRODUCT_POPUP: 'OPEN_CLOSE_PRODUCT_POPUP',
   SHOW_POPUP: 'SHOW_POPUP',
   HIDE_POPUP: 'HIDE_POPUP',
   SHOW_SIDE_NAV: 'SHOW_SIDE_NAV',
   HIDE_SIDE_NAV: 'HIDE_SIDE_NAV',
   TOGGLE_SIDE_NAV: 'TOGGLE_SIDE_NAV',
};
export default type;
